import { initNeoletterFormWidgets } from "scrivito-neoletter-form-widgets"
import { isWeb } from "shared/lib/runtimeEnvironment"

if (isWeb()) {
  initNeoletterFormWidgets({
    captchaOptions: {
      siteKey: import.meta.env.VITE_CAPTCHA_SITE_KEY,
      captchaType: "google-recaptcha"
    }
  })
}

import.meta.glob(
  [
    "./**/*WidgetClass.ts",
    "./**/*WidgetClass.tsx",
    "./**/*WidgetComponent.ts",
    "./**/*WidgetComponent.tsx",
    "!./**/__tests__/*.ts",
    "!./**/__tests__/*.tsx"
  ],
  {
    eager: true
  }
)
